import React from "react";
import Logo from "../Assets/SahakaryaLOGO-removebg-preview.png";
import { Box, Grid, Typography, Link, IconButton, Divider } from "@mui/material";
import { Instagram, YouTube } from "@mui/icons-material";

const Footer = () => {
  return (
    <Box sx={styles.footerContainer}>
      <Grid container spacing={3} sx={styles.footerWrapper}>
        {/* Section One: Logo & Social Icons */}
        <Grid item xs={12} md={4} sx={styles.sectionOne}>
          <Box sx={styles.logoContainer}>
            <img src={Logo} alt="Sahakarya Logo" style={{ width: 156 }} />
          </Box>
          <Box sx={styles.socialIcons}>
            <IconButton
              component="a"
              href="https://www.instagram.com/sahakarya__pratishthan?igsh=ajNsdTh4aGFlNGsz"
              target="_blank"
              rel="noopener noreferrer"
              sx={styles.icon}
            >
              <Instagram />
            </IconButton>
            <IconButton
              component="a"
              href="https://youtube.com/channel/UCGLQ47UyXpYLWEAn_dJbcDA?si=93C4Urzi16HlGFmu"
              target="_blank"
              rel="noopener noreferrer"
              sx={styles.icon}
            >
              <YouTube />
            </IconButton>
          </Box>
        </Grid>

        {/* Section Two: Links */}
        <Grid item xs={12} md={4} sx={styles.sectionTwo}>
          <Typography variant="h6">About Us</Typography>
          <Link href="/about" sx={styles.link}>Our Vision and Mission</Link>
          <Link href="/certificates" sx={styles.link}>Certified NGO</Link>
          <Link href="/team" sx={styles.link}>Team</Link>
          <Typography variant="h6" mt={2}>Policies</Typography>
          <Link href="#" sx={styles.link}>Terms & Conditions</Link>
          <Link href="#" sx={styles.link}>Privacy Policy</Link>
        </Grid>

        <Grid item xs={12} md={4} sx={styles.sectionThree}>
          <Typography variant="h6">Our Work</Typography>
          <Link href="/education" sx={styles.link}>Education</Link>
          <Link href="/health" sx={styles.link}>Health</Link>
          <Link href="/treeplantation" sx={styles.link}>Tree Plantation</Link>
          <Link href="/waterwildlife" sx={styles.link}>Water For Wildlife</Link>
          <Link href="/foodDonation" sx={styles.link}>Donate Food</Link>
          <Link href="/extraActivity" sx={styles.link}>Extra Activity</Link>
        </Grid>
      </Grid>

      {/* Divider Line */}
      <Divider sx={styles.divider} />

      {/* Address Section */}
      <Box sx={styles.footerAddress}>
        <Typography variant="body2">Address: 64 B, Om Nagar, Deopur, Dhule</Typography>
        <Typography variant="body2">Email: sahakaryapratishthan.joinus@gmail.com</Typography>
        <Typography variant="body2">Phone: +91 8265044891, +91 9404476136</Typography>
      </Box>
    </Box>
  );
};

// Styling
const styles = {
  footerContainer: {
    backgroundColor: "#ffff",
    padding: "2rem 0",
    textAlign: "center",
  },
  footerWrapper: {
    maxWidth: "1200px",
    margin: "0 auto",
  },
  sectionOne: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  logoContainer: {
    marginBottom: "1rem",
  },
  socialIcons: {
    display: "flex",
    gap: "10px",
  },
  icon: {
    color: "#333",
    "&:hover": {
      color: "#FF7F50",
      transform: "scale(1.2)",
      transition: "0.3s",
    },
  },
  sectionTwo: {
    display: "flex",
    flexDirection: "column",
    alignItems: { xs: "center", md: "flex-start" },
  },
  sectionThree: {
    display: "flex",
    flexDirection: "column",
    alignItems: { xs: "center", md: "flex-start" },
  },
  link: {
    textDecoration: "none",
    color: "#333",
    fontSize: "0.9rem",
    marginTop: "5px",
    "&:hover": {
      color: "#FF7F50",
      fontSize: "1.1rem",
      transition: "0.3s ease-in-out",
    },
  },
  divider: {
    width: "80%",
    margin: "1rem auto",
    backgroundColor: "#ccc",
  },
  footerAddress: {
    textAlign: "center",
    fontSize: "0.9rem",
    color: "#666",
  },
};

export default Footer;
